import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import AppLayout from '@/components/layout/AppLayout'
import AvailabilityPage from '@/pages/AvailabilityPage'
import StructuresPage from '@/pages/StructuresPage'
import MonitoringPage from '@/pages/MonitoringPage'
import OrientationPage from '@/pages/OrientationPage'
import HistoryPage from '@/pages/HistoryPage'
import DashboardPage from '@/pages/DashboardPage'
import StocksPage from '@/pages/StocksPage'
import CmuCheckPage from '@/pages/CmuCheckPage'
import TemplateEditorPage from '@/pages/TemplateEditorPage'
import DossierPage from '@/pages/DossierPage'
import UrgencePage from '@/pages/UrgencePage'

export default function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { borderRadius: '8px', padding: '12px 16px', fontSize: '14px' },
          success: { iconTheme: { primary: '#16a34a', secondary: '#fff' } },
          error: { iconTheme: { primary: '#dc2626', secondary: '#fff' }, duration: 8000 },
        }}
      />
      <Routes>
        {/* Standalone pages — no sidebar (for QR code / citizen access) */}
        <Route path="/dossier/:ref" element={<DossierPage />} />
        <Route path="/urgence" element={<UrgencePage />} />
        <Route element={<AppLayout />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/availability" element={<AvailabilityPage />} />
          <Route path="/structures" element={<StructuresPage />} />
          <Route path="/monitoring" element={<MonitoringPage />} />
          <Route path="/orientation" element={<OrientationPage />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/stocks" element={<StocksPage />} />
          <Route path="/tooling/cmu-check" element={<CmuCheckPage />} />
          <Route path="/admin/templates" element={<TemplateEditorPage />} />
        </Route>
      </Routes>
    </>
  )
}
